// import ReactECharts from 'echarts-for-react';
// import { useState, useEffect } from "react";
// import Chart from "react-apexcharts";
// import { useSelector } from "react-redux";
// import '../../../../cssfiles/homepage.css';
// import dayjs from 'dayjs';

// const LineChart = (props) => {
//     const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
//     const dateformatselected = useSelector((state) => state.mainpagedata.selecteddate);
//     const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates);
//     const dateselected = useSelector((state) => state.mainpagedata.selecteddate);

//     const [seriesChart, setSeriesChart] = useState([]);
//     const [options, setOptions] = useState({});

//     const theme = useSelector((state) => state.themedata.theme);

//     useEffect(() => {
//         // Early validation inside useEffect - don't return early before hooks
//         if (!props || !props.widgetprop || !props.widgetprop.props || !props.widgetprop.props.extended) {
//             console.log("Required props are missing");
//             setSeriesChart([]);
//             setOptions({});
//             return;
//         }
//         // Validate required data
//         if (!props?.widgetprop?.props?.extended?.tagprops) {
//             console.log("Tag properties not available");
//             return;
//         }

//         if (!tagcollectionvalue || typeof tagcollectionvalue !== 'object') {
//             console.log("Tag collection values not available");
//             return;
//         }

//         const tagProperties = props.widgetprop.props.extended.tagprops;
        
//         // Validate tagProperties is an array
//         if (!Array.isArray(tagProperties) || tagProperties.length === 0) {
//             console.log("Tag properties is not a valid array or is empty");
//             return;
//         }

//         const colorPropertiesGeneral = [];
//         const colorPropertiesLines = [];
//         const widthPropertiesLines = [];
//         const curvePropertiesLines = [];
//         const legendNamePropertiesLines = [];

//         const colorPropertiesBars = [];
//         const widthPropertiesBars = [];
//         const curvePropertiesBars = [];
//         const legendNamePropertiesBars = [];

//         const colorPropertiesMarkers = [];
//         const widthPropertiesMarkers = [];
//         const curvePropertiesMarkers = [];
//         const legendNamePropertiesMarkers = [];

//         // Process tag properties with validation
//         tagProperties.forEach(chartType => {
//             if (chartType && chartType.chartprops && chartType.legendname) {
//                 colorPropertiesGeneral.push(chartType.chartprops.color || '#000000');
//                 colorPropertiesLines.push(chartType.chartprops.color || '#000000');
//                 widthPropertiesLines.push(2);
//                 curvePropertiesLines.push('smooth');
//                 legendNamePropertiesLines.push(chartType.legendname);
//             }
//         });

//         // Build series data with proper validation
//         const seriesConsumed = tagProperties.map(chartType => {
//             if (!chartType || !chartType.tagid || !chartType.legendname) {
//                 return null;
//             }

//             if (!tagcollectionvalue.hasOwnProperty(chartType.tagid)) {
//                 return null;
//             }

//             if (chartType.charttype === "maxlimit" || chartType.charttype === "minlimit") {
//                 return null;
//             }

//             const tagData = tagcollectionvalue[chartType.tagid];
            
//             // Validate tag data
//             if (!tagData || !Array.isArray(tagData)) {
//                 return null;
//             }

//             // Process data points with validation
//             const processedData = tagData.map(currentobj => {
//                 if (!currentobj || typeof currentobj !== 'object') {
//                     return null;
//                 }

//                 // Ensure x and y values exist and are valid
//                 if (currentobj.x === null || currentobj.x === undefined || 
//                     currentobj.y === null || currentobj.y === undefined) {
//                     return null;
//                 }

//                 return {
//                     x: currentobj.x,
//                     y: currentobj.y
//                 };
//             }).filter(item => item !== null);

//             return {
//                 name: chartType.legendname,
//                 type: chartType.charttype || 'line',
//                 data: processedData
//             };
//         }).filter(item => item !== null && item.data && item.data.length > 0);

//         // Don't proceed if no valid series data
//         if (seriesConsumed == undefined || !seriesConsumed || seriesConsumed.length === 0) {
//             console.log("No valid series data available");
//             setSeriesChart([]);
//             setOptions({});
//             return;
//         }

//         // Safe access to extended properties with defaults
//         const extendedProps = props.widgetprop.props.extended;
//         const basicProps = props.widgetprop.props.basic || {};

//         const yaxisProperties = {
//             forceNiceScale: true,
//             labels: {
//                 show: true,
//                 style: {
//                     colors: 'var(--axis-color)',
//                     fontSize: extendedProps.fontsize || '12px',
//                     fontFamily: extendedProps.fontfamily || 'Arial',
//                     fontWeight: extendedProps.fontweight || 'normal',
//                 },
//                 formatter: (value) => { 
//                     if (value == null || isNaN(value)) {
//                         return '';
//                     }
//                     return Number(value).toFixed(2);
//                 },
//             },
//             title: {
//                 text: extendedProps.title?.titlename || "",
//                 style: {
//                     color: 'var(--axis-title-color)',
//                     fontSize: extendedProps.title?.fontsize || '14px',
//                     fontFamily: extendedProps.title?.fontfamily || 'Arial',
//                     fontWeight: extendedProps.title?.fontweight || 'bold',
//                 },
//             },
//         };

//         const optionsConsumption = {
//             chart: {
//                 zoom: {
//                     enabled: false,
//                 },
//                 type: "line",
//                 toolbar: {
//                     show: false
//                 },
//                 offsetX: 0
//             },
//             grid: {
//                 show: true,
//                 borderColor: 'var(--grey-variation)',
//             },
//             stroke: {
//                 show: true,
//                 width: widthPropertiesLines.length > 0 ? widthPropertiesLines : [2],
//                 curve: curvePropertiesLines.length > 0 ? curvePropertiesLines : ['smooth'],
//             },
//             fill: {
//                 opacity: 1,
//                 type: 'solid',
//             },
//             colors: colorPropertiesLines.length > 0 ? colorPropertiesLines : ['#008FFB'],
//             plotOptions: {
//                 line: {}
//             },
//             dataLabels: {
//                 enabled: extendedProps.dataLabels_enabled || false
//             },
//             xaxis: {
//                 type: 'datetime',
//                 tickAmount: Math.max(1, (seriesConsumed[0]?.data?.length || 1) - 1),
//                 tickPlacement: 'between',
//                 tooltip: {
//                     enabled: false
//                 },
//                 axisBorder: {
//                     show: true,
//                     color: 'var(--axis-color)',
//                 },
//                 axisTicks: {
//                     show: true,
//                     height: 3,
//                     color: 'var(--axis-color)',
//                 },
//                 labels: {
//                     show: true,
//                     rotate: -45,
//                     rotateAlways: false,
//                     hideOverlappingLabels: true,
//                     style: {
//                         colors: 'var(--axis-color)',
//                         fontSize: extendedProps.fontsize || '12px',
//                         fontFamily: extendedProps.fontfamily || 'Arial',
//                         fontWeight: extendedProps.fontweight || 'normal',
//                     },
//                     formatter: function(value, timestamp, opts) {
//                         if (!opts || !opts.w || !opts.w.config || !opts.w.config.series) {
//                             return '';
//                         }

//                         if (isNaN(value)) {
//                             return '';
//                         }
                    
//                         const index = opts.i;
//                         if (index === undefined || !opts.w.config.series[0] || !opts.w.config.series[0].data) {
//                             return '';
//                         }

//                         const thistimestamp = opts.w.config.series[0].data[index]?.x;
                        
//                         if (!thistimestamp) {
//                             return '';
//                         }

//                         const currentformatteddate = new Date(thistimestamp);
//                         if (isNaN(currentformatteddate.getTime())) {
//                             return '';
//                         }

//                         let currxvalue = '';
//                         const options = { timeZone: "Asia/Kolkata" };
                    
//                         if(currentformatteddate){
//                             switch (dateformatselected) {
//                                 case 'This Year':
//                                 case 'Last Year':
//                                     currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, month: "short" });
//                                     break;
//                                 case 'This Month':
//                                 case 'Last Month':
//                                 case 'Last 30 days':
//                                     currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric" });
//                                     break;
//                                 case 'This Week':
//                                 case 'Last Week':
//                                 case 'Last 7 days':
//                                     currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, weekday: "short" });
//                                     break;
//                                 case 'Today':
//                                 case 'Yesterday':
//                                     // const hrs = currentformatteddate.getHours();
//                                     // currxvalue = hrs.toString().padStart(2, '0');
                                    
//                                     // if ((dateformatselected === 'Today' && Number(basicProps.width) <= 6) || 
//                                     //     (dateformatselected === 'Yesterday' && Number(basicProps.width) <= 6)) {
//                                     //     if (index % 2 === 0) {
//                                     //         currxvalue = '';
//                                     //     }
//                                     // }
//                                     // break;
//                                     var hrs=  currentformatteddate.getHours();
//                                     var hrsstring = hrs.toString();
//                                     if(hrsstring.length<2){
//                                         hrsstring = "0"+hrsstring;
//                                     }
//                                     currxvalue = hrsstring;
//                                     break;
//                                 case 'Last 24 hours':
//                                     const hrs24 = currentformatteddate.getHours();
//                                     const mins = currentformatteddate.getMinutes();
//                                     currxvalue = `${hrs24.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
//                                     break;
//                                 case 'Custom':
//                                     if (seriesConsumed[0]?.data?.length > 30) {
//                                         currxvalue = (currentformatteddate.getDate() === 1) 
//                                             ? currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric", month: "short" }) 
//                                             : '';
//                                     } else {
//                                         currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric" });
//                                     }
//                                     break;
//                                 default:
//                                     currxvalue = '';
//                                     break;
//                             }
                        
//                             return currxvalue;

//                         }else{
//                             return '';
//                         }
                       
//                     }  
//                 },
//             },
//             yaxis: yaxisProperties,
//             tooltip: {
//                 enabled: true,
//                 enabledOnSeries: undefined,
//                 custom: function({ series, seriesIndex, dataPointIndex, w }) {
//                     if (!series || !series[seriesIndex] || series[seriesIndex][dataPointIndex] === undefined) {
//                         return '<div>No data</div>';
//                     }

//                     const value = series[seriesIndex][dataPointIndex];
//                     const timestamp = w.globals.seriesX?.[seriesIndex]?.[dataPointIndex];
                
//                     if (!timestamp) {
//                         return '<div>No timestamp data</div>';
//                     }

//                     const currentFormattedDate = new Date(timestamp);
//                     if (isNaN(currentFormattedDate.getTime())) {
//                         return '<div>Invalid date</div>';
//                     }
                    
//                     let tooltipString = `<div style="display:flex; flex-direction:column; padding:5px; background-color:#005C8E;">`;
//                     const options = { 
//                         year: 'numeric', 
//                         month: '2-digit', 
//                         day: '2-digit', 
//                         hour: '2-digit', 
//                         minute: '2-digit', 
//                         hour12: false 
//                     }; 
//                     const formattedDate = currentFormattedDate.toLocaleDateString('en-US', options).replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/g, '$3-$1-$2');

//                     tooltipString += `<div style="font-weight:600; color:#FFFFFF; background-color:#005C8E;">${formattedDate}</div>`;
                    
//                     for (let i = 0; i < series.length; i++) {
//                         if (series[i] && series[i][dataPointIndex] !== undefined && seriesConsumed[i]) {
//                             const seriesValue = series[i][dataPointIndex];
//                             const color = w.config.colors?.[i] || '#000000';
//                             tooltipString += `
//                             <div style="display:flex; align-items:center; margin-bottom:4px;">
//                                 <div style="height:8px; width:8px; background-color:${color}; border-radius:50%; margin-right:8px;"></div>
//                                 <div style="font-weight:600; color:#FFFFFF;">${seriesConsumed[i].name}</div>
//                                 <div style="margin-left:12px; color:#FFFFFF;">${(seriesValue == null) ? "No Value" : Number(seriesValue).toFixed(2)}</div>
//                             </div>
//                             `;
//                         }
//                     }
//                     tooltipString += `</div>`;
//                     return tooltipString;
//                 },
                
//                 hideEmptySeries: true,
//                 fillSeriesColor: false,
//                 theme: false,
//                 borderRadius: 0,
//                 style: {
//                     fontSize: "12px",
//                     fontWeight: 800,
//                     fontFamily: 'Roboto',
//                 },
//             },
//             legend: {
//                 show: true,
//                 fontSize: extendedProps.legend?.fontsize || '12px',
//                 fontFamily: extendedProps.legend?.fontfamily || 'Arial',
//                 fontWeight: extendedProps.legend?.fontweight || 'normal',
//                 labels: {
//                     colors: Array(colorPropertiesLines.length).fill('var(--legend-text-color)')
//                 },
//                 customLegendItems: legendNamePropertiesLines,
//                 markers: {
//                     radius: extendedProps.legend?.marker?.radius || 6,
//                     height: extendedProps.legend?.marker?.height || 12,
//                     width: extendedProps.legend?.marker?.width || 12,
//                     fillColors: colorPropertiesLines
//                 }
//             },
//             responsive: [
//                 {
//                     breakpoint: 1000,
//                     options: {
//                         xaxis: {
//                             labels: {
//                                 rotate: -45,
//                                 rotateAlways: true,
//                             }
//                         }
//                     }
//                 },
//                 {
//                     breakpoint: 600,
//                     options: {
//                         xaxis: {
//                             labels: {
//                                 rotate: -60,
//                                 rotateAlways: true,
//                             }
//                         }
//                     }
//                 }
//             ],
//         };

//         setSeriesChart(seriesConsumed);
//         setOptions(optionsConsumption);
//     }, [props.widgetprop, tagcollectionvalue, dateformatselected]);

//     // Don't render if no data or if props are missing
//     if (!props || !props.widgetprop || !props.widgetprop.props || !props.widgetprop.props.extended) {
//         return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '85%' }}>Loading chart...</div>;
//     }

//     if (!seriesChart || seriesChart.length === 0) {
//         return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '85%' }}>No data available</div>;
//     }

//     return (
//         <>
//             <Chart options={options} series={seriesChart} type='line' height="85%" width="100%" />
//         </>
//     );
// };

// export default LineChart;
import ReactECharts from 'echarts-for-react';
import { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";
import '../../../../cssfiles/homepage.css';
import dayjs from 'dayjs';

const LineChart = (props) => {
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
    const dateformatselected = useSelector((state) => state.mainpagedata.selecteddate);
    const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates);
    const dateselected = useSelector((state) => state.mainpagedata.selecteddate);

    const [seriesChart, setSeriesChart] = useState([]);
    const [options, setOptions] = useState({});

    const theme = useSelector((state) => state.themedata.theme);

    useEffect(() => {
        // Early validation inside useEffect - don't return early before hooks
        if (!props || !props.widgetprop || !props.widgetprop.props || !props.widgetprop.props.extended) {
            console.log("Required props are missing");
            setSeriesChart([]);
            setOptions({});
            return;
        }

        // Extract widgetName early — needed before tagprops check because
        // text widgets (e.g. "Forecast Overview") have NO tagprops at all.
        // If we check tagprops first, the text widget would be rejected before
        // we ever get a chance to handle it.
        const widgetName = props.widgetprop?.widgetname?.trim().toLowerCase();

        // ─────────────────────────────────────────────────────────────────────
        // CONDITION 0 — FORECAST OVERVIEW (TEXT WIDGET)
        //
        // widgetname === "forecast overview"
        // type       === "textwidget"
        //
        // This widget has NO tagprops, NO series data, NO chart.
        // It purely renders a styled text block from extended.text.
        // It must be intercepted HERE — before the tagprops guard below —
        // otherwise the guard would reject it and the component would silently
        // return nothing (blank card).
        //
        // ── EXCEPTION GUARDS ─────────────────────────────────────────────────
        //   extended.text missing / not a string
        //     → "No description available." fallback shown — no crash
        //   extended.text is empty string ("")
        //     → fallback shown — blank text is treated same as missing
        //   extended.fontsize / fontfamily / fontweight / color missing
        //     → each defaults to a safe hardcoded value — no crash
        //   extended.textalign is an invalid CSS value
        //     → browser ignores it gracefully; defaults to 'left'
        //   extended.lineheight missing
        //     → defaults to '1.7' — comfortable reading line spacing
        //   props.widgetprop.props.basic missing
        //     → destructured with || {} so no undefined access crash
        //   theme (dark/light) value missing
        //     → color defaults to '#333333' (light) — readable on any bg
        // ─────────────────────────────────────────────────────────────────────
        if (widgetName === "forecast overview") {
            // No setSeriesChart / setOptions needed — this widget skips the chart entirely.
            // Return early from useEffect so no chart state is touched.
            return;
        }
        // ─────────────────────────────────────────────────────────────────────
        // END CONDITION 0
        // ─────────────────────────────────────────────────────────────────────

        if (!props?.widgetprop?.props?.extended?.tagprops) {
            console.log("Tag properties not available");
            return;
        }

        const tagProperties = props.widgetprop.props.extended.tagprops;

        if (!Array.isArray(tagProperties) || tagProperties.length === 0) {
            console.log("Tag properties is not a valid array or is empty");
            return;
        }

        // ─────────────────────────────────────────────────────────────────────
        // CONDITION 1 — FORECAST VS ACTUAL
        // Data is embedded in tagprops[i].data (no Redux store lookup needed).
        // Actual series → solid line, Predicted → dashed line via dashArray.
        // ─────────────────────────────────────────────────────────────────────
        if (widgetName === "forecast vs actual") {
            const colorPropertiesLines = [];
            const widthPropertiesLines = [];
            const curvePropertiesLines = [];
            const legendNamePropertiesLines = [];

            const seriesConsumed = tagProperties.map((chartType) => {
                if (!chartType || !chartType.legendname) return null;

                const rawData = chartType.data;
                if (!rawData || !Array.isArray(rawData) || rawData.length === 0) return null;

                const processedData = rawData
                    .map((point) => {
                        if (!point || point.x === undefined || point.y === undefined) return null;
                        return {
                            x: new Date(point.x).getTime(),
                            y: point.y
                        };
                    })
                    .filter(Boolean);

                colorPropertiesLines.push(chartType.chartprops?.color || '#000000');
                widthPropertiesLines.push(chartType.chartprops?.strokeWidth || 2);
                curvePropertiesLines.push(
                    (chartType.chartprops?.dashArray || 0) > 0 ? 'straight' : 'smooth'
                );
                legendNamePropertiesLines.push(chartType.legendname);

                return {
                    name: chartType.legendname,
                    type: chartType.charttype || 'line',
                    data: processedData
                };
            }).filter((item) => item !== null && item.data && item.data.length > 0);

            if (!seriesConsumed || seriesConsumed.length === 0) {
                console.log("No valid forecast series data");
                setSeriesChart([]);
                setOptions({});
                return;
            }

            const extendedProps = props.widgetprop.props.extended;

            const forecastOptions = {
                chart: {
                    zoom: { enabled: false },
                    type: "line",
                    toolbar: { show: false },
                    offsetX: 0
                },
                grid: { show: true, borderColor: 'var(--grey-variation)' },
                stroke: {
                    show: true,
                    width: widthPropertiesLines,
                    curve: curvePropertiesLines,
                    dashArray: tagProperties.map((t) => t?.chartprops?.dashArray || 0)
                },
                fill: { opacity: 1, type: 'solid' },
                colors: colorPropertiesLines,
                dataLabels: { enabled: extendedProps.dataLabels_enabled || false },
                xaxis: {
                    type: 'datetime',
                    tickAmount: Math.max(1, (seriesConsumed[0]?.data?.length || 1) - 1),
                    tickPlacement: 'between',
                    tooltip: { enabled: false },
                    axisBorder: { show: true, color: 'var(--axis-color)' },
                    axisTicks: { show: true, height: 3, color: 'var(--axis-color)' },
                    labels: {
                        show: true,
                        rotate: -45,
                        rotateAlways: false,
                        hideOverlappingLabels: true,
                        style: {
                            colors: 'var(--axis-color)',
                            fontSize: extendedProps.fontsize || '12px',
                            fontFamily: extendedProps.fontfamily || 'Arial',
                            fontWeight: extendedProps.fontweight || 'normal',
                        },
                        formatter: function (value) {
                            if (isNaN(value)) return '';
                            const d = new Date(value);
                            return d.toLocaleDateString('en-US', {
                                timeZone: 'Asia/Kolkata',
                                day: 'numeric',
                                month: 'short'
                            });
                        }
                    }
                },
                yaxis: {
                    forceNiceScale: true,
                    labels: {
                        show: true,
                        style: {
                            colors: 'var(--axis-color)',
                            fontSize: extendedProps.fontsize || '12px',
                            fontFamily: extendedProps.fontfamily || 'Arial',
                            fontWeight: extendedProps.fontweight || 'normal',
                        },
                        formatter: (value) => {
                            if (value == null || isNaN(value)) return '';
                            return Number(value).toFixed(2);
                        }
                    },
                    title: {
                        text: extendedProps.title?.titlename || "",
                        style: {
                            color: 'var(--axis-title-color)',
                            fontSize: extendedProps.title?.fontsize || '14px',
                            fontFamily: extendedProps.title?.fontfamily || 'Arial',
                            fontWeight: extendedProps.title?.fontweight || 'bold',
                        }
                    }
                },
                tooltip: {
                    enabled: true,
                    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                        if (!series || !series[seriesIndex] || series[seriesIndex][dataPointIndex] === undefined) {
                            return '<div>No data</div>';
                        }
                        const timestamp = w.globals.seriesX?.[seriesIndex]?.[dataPointIndex];
                        if (!timestamp) return '<div>No timestamp</div>';

                        const d = new Date(timestamp);
                        const formattedDate = d.toLocaleDateString('en-US', {
                            timeZone: 'Asia/Kolkata',
                            year: 'numeric', month: 'short', day: 'numeric'
                        });

                        let tooltipString = `<div style="display:flex;flex-direction:column;padding:5px;background-color:#005C8E;">`;
                        tooltipString += `<div style="font-weight:600;color:#FFFFFF;margin-bottom:4px;">${formattedDate}</div>`;

                        for (let i = 0; i < series.length; i++) {
                            if (series[i] && series[i][dataPointIndex] !== undefined && seriesConsumed[i]) {
                                const val = series[i][dataPointIndex];
                                const color = w.config.colors?.[i] || '#000000';
                                tooltipString += `
                                <div style="display:flex;align-items:center;margin-bottom:4px;">
                                    <div style="height:8px;width:8px;background-color:${color};border-radius:50%;margin-right:8px;"></div>
                                    <div style="font-weight:600;color:#FFFFFF;">${seriesConsumed[i].name}</div>
                                    <div style="margin-left:12px;color:#FFFFFF;">${val == null ? "No Value" : Number(val).toFixed(2)}</div>
                                </div>`;
                            }
                        }
                        tooltipString += `</div>`;
                        return tooltipString;
                    },
                    hideEmptySeries: true,
                    fillSeriesColor: false,
                    theme: false,
                    style: { fontSize: "12px", fontWeight: 800, fontFamily: 'Roboto' }
                },
                legend: {
                    show: true,
                    fontSize: extendedProps.legend?.fontsize || '12px',
                    fontFamily: extendedProps.legend?.fontfamily || 'Arial',
                    fontWeight: extendedProps.legend?.fontweight || 'normal',
                    labels: { colors: Array(colorPropertiesLines.length).fill('var(--legend-text-color)') },
                    customLegendItems: legendNamePropertiesLines,
                    markers: {
                        radius: extendedProps.legend?.marker?.radius || 6,
                        height: extendedProps.legend?.marker?.height || 12,
                        width: extendedProps.legend?.marker?.width || 12,
                        fillColors: colorPropertiesLines
                    }
                }
            };

            setSeriesChart(seriesConsumed);
            setOptions(forecastOptions);
            return; // Exit — skip standard Redux-based flow
        }
        // ─────────────────────────────────────────────────────────────────────
        // END CONDITION 1
        // ─────────────────────────────────────────────────────────────────────


        // ─────────────────────────────────────────────────────────────────────
        // CONDITION 2 — ENERGY VS TEMPERATURE CORRELATION
        //
        // Chart layout:
        //   X-axis        → Dates (datetime)
        //   Left Y-axis   (index 0) → Energy (kWh) — blue solid + blue dashed
        //   Right Y-axis  (index 1) → Temperature (°C) — red solid + red dashed
        //   4 total series: Energy Actual | Energy Predicted | Temp Actual | Temp Predicted
        //
        // Data source: tagprops[i].data as { x: "YYYY-MM-DD", y: value }
        //              tagprops[i].yaxis_index  → 0 = left (energy), 1 = right (temp)
        //              tagprops[i].chartprops.dashArray → 0 = solid, >0 = dashed
        //
        // Correlation: extended.correlation_coefficient → Pearson r in shared tooltip
        //
        // ── EXCEPTION GUARDS ─────────────────────────────────────────────────
        //   tagprop missing legendname  → series skipped (console.warn)
        //   tagprop missing .data       → series skipped (console.warn)
        //   .data not an array          → series skipped (console.warn)
        //   .data empty array           → series skipped (console.warn)
        //   point not an object         → point dropped (console.warn)
        //   point.x / .y missing        → point dropped (console.warn)
        //   new Date(point.x) is NaN    → point dropped (console.warn)
        //   point.y is NaN              → point dropped (console.warn)
        //   all points invalid          → series dropped (console.warn)
        //   all series invalid          → setSeriesChart([]), "No data" shown
        //   corrCoeff not finite        → Pearson r line in tooltip skipped (safe)
        //   yaxis_index missing/invalid → defaults to 0 (left axis)
        //   yaxis label value NaN       → returns '' (no "NaN kWh" on axis)
        //   xaxis label value NaN       → returns '' (no "NaN" on axis)
        //   tooltip timestamp invalid   → fallback "Invalid date" tooltip shown
        // ─────────────────────────────────────────────────────────────────────
        if (widgetName === "energy vs temperature correlation") {

            const colorPropertiesCorr  = [];
            const legendNamesCorr      = [];
            const dashArrayCorr        = [];
            const strokeWidthCorr      = [];
            const yAxisIndexPerSeries  = [];

            const seriesConsumed = tagProperties.map((chartType) => {

                // EXCEPTION: malformed tagprop or missing legend label
                if (!chartType || !chartType.legendname) {
                    console.warn("[Correlation] Skipping tagprop — missing legendname:", chartType);
                    return null;
                }

                const rawData = chartType.data;

                // EXCEPTION: .data key entirely absent
                if (!rawData) {
                    console.warn("[Correlation] Skipping '" + chartType.legendname + "' — 'data' key missing.");
                    return null;
                }

                // EXCEPTION: .data is not an array
                if (!Array.isArray(rawData)) {
                    console.warn("[Correlation] Skipping '" + chartType.legendname + "' — 'data' is " + typeof rawData + ", expected Array.");
                    return null;
                }

                // EXCEPTION: .data is empty
                if (rawData.length === 0) {
                    console.warn("[Correlation] Skipping '" + chartType.legendname + "' — 'data' array is empty.");
                    return null;
                }

                // Data points: x = "YYYY-MM-DD" → converted to timestamp ms for ApexCharts datetime axis
                const processedData = rawData.map((point, idx) => {

                    // EXCEPTION: point is not an object
                    if (!point || typeof point !== 'object') {
                        console.warn("[Correlation] point[" + idx + "] not an object:", point);
                        return null;
                    }

                    // EXCEPTION: x or y missing/null
                    if (point.x === undefined || point.x === null ||
                        point.y === undefined || point.y === null) {
                        console.warn("[Correlation] point[" + idx + "] missing x or y:", point);
                        return null;
                    }

                    const ts   = new Date(point.x).getTime();
                    const yVal = parseFloat(point.y);

                    // EXCEPTION: unparseable date string → NaN timestamp
                    if (isNaN(ts)) {
                        console.warn("[Correlation] point[" + idx + "] invalid date: '" + point.x + "'");
                        return null;
                    }

                    // EXCEPTION: non-numeric y value after parseFloat
                    if (isNaN(yVal)) {
                        console.warn("[Correlation] point[" + idx + "] NaN y: '" + point.y + "'");
                        return null;
                    }

                    return { x: ts, y: yVal };
                }).filter(Boolean);

                // EXCEPTION: all points in this series were invalid
                if (processedData.length === 0) {
                    console.warn("[Correlation] All points invalid for '" + chartType.legendname + "' — series dropped.");
                    return null;
                }

                // Per-series display props from JSON
                const dash  = chartType.chartprops?.dashArray  ?? 0;
                const sw    = chartType.chartprops?.strokeWidth ?? 2;
                const color = chartType.chartprops?.color || '#000000';
                // EXCEPTION: yaxis_index missing/non-integer → default 0 (left axis)
                const yIdx  = Number.isInteger(chartType.yaxis_index) ? chartType.yaxis_index : 0;

                colorPropertiesCorr.push(color);
                legendNamesCorr.push(chartType.legendname);
                dashArrayCorr.push(dash);
                strokeWidthCorr.push(sw);
                yAxisIndexPerSeries.push(yIdx);

                return {
                    name: chartType.legendname,
                    type: 'line',
                    data: processedData
                };
            }).filter((item) => item !== null && item.data && item.data.length > 0);

            // EXCEPTION: every series was invalid
            if (!seriesConsumed || seriesConsumed.length === 0) {
                console.error("[Correlation] No valid series — check tagprops[i].data contains {x:'YYYY-MM-DD', y:number} points.");
                setSeriesChart([]);
                setOptions({});
                return;
            }

            const extendedProps = props.widgetprop.props.extended;

            // EXCEPTION: corrCoeff absent or non-finite → Pearson r line in tooltip skipped safely
            const corrCoeff = (extendedProps.correlation_coefficient !== undefined &&
                               extendedProps.correlation_coefficient !== null &&
                               isFinite(Number(extendedProps.correlation_coefficient)))
                ? Number(extendedProps.correlation_coefficient)
                : null;

            const leftAxisProp  = tagProperties.find(t => (t?.yaxis_index ?? 0) === 0);
            const rightAxisProp = tagProperties.find(t => (t?.yaxis_index ?? 0) === 1);

            const axisLabelStyle = {
                colors: 'var(--axis-color)',
                fontSize: extendedProps.fontsize || '12px',
                fontFamily: extendedProps.fontfamily || 'Arial',
                fontWeight: extendedProps.fontweight || 'normal',
            };
            const axisTitleStyle = {
                color: 'var(--axis-title-color)',
                fontSize: extendedProps.title?.fontsize || '11px',
                fontFamily: extendedProps.title?.fontfamily || 'Arial',
                fontWeight: extendedProps.title?.fontweight || 'bold',
            };

            const correlationOptions = {
                chart: {
                    type: 'line',
                    zoom: { enabled: false },
                    toolbar: { show: false },
                    offsetX: 0
                },
                grid: { show: true, borderColor: 'var(--grey-variation)' },
                // Per-series stroke arrays: width and dashArray map 1-to-1 with seriesConsumed
                stroke: {
                    show: true,
                    curve: 'smooth',
                    width: strokeWidthCorr,   // [2,2,2,2]
                    dashArray: dashArrayCorr  // [0,5,0,5] — solid actual, dashed predicted
                },
                fill: { opacity: 1, type: 'solid' },
                colors: colorPropertiesCorr, // [blue, blue, red, red]
                markers: { size: 0, hover: { sizeOffset: 3 } },
                dataLabels: { enabled: false },
                xaxis: {
                    type: 'datetime',
                    tickAmount: 8,
                    tooltip: { enabled: false },
                    axisBorder: { show: true, color: 'var(--axis-color)' },
                    axisTicks:  { show: true, height: 3, color: 'var(--axis-color)' },
                    labels: {
                        show: true,
                        rotate: -45,
                        rotateAlways: false,
                        hideOverlappingLabels: true,
                        style: axisLabelStyle,
                        formatter: function (value) {
                            // EXCEPTION: invalid/NaN timestamp → '' to avoid "NaN" on x-axis
                            if (!value || isNaN(value)) return '';
                            const d = new Date(value);
                            if (isNaN(d.getTime())) return '';
                            return d.toLocaleDateString('en-US', {
                                timeZone: 'Asia/Kolkata',
                                day: 'numeric',
                                month: 'short'
                            });
                        }
                    }
                },
                // ── DUAL Y-AXIS — ONE ENTRY PER SERIES (ApexCharts requirement) ──────
                // ApexCharts matches yaxis[] entries POSITIONALLY to series[].
                // yaxis.length MUST equal seriesConsumed.length (4 series → 4 yaxis entries).
                //
                // ── ROOT CAUSE OF "predicted values look too low" BUG ────────────────
                //
                // BUG: seriesName was set to s.name (each series' OWN name) for every
                //      yaxis entry, including the non-anchor/secondary ones.
                //
                // WHY THIS BREAKS SCALING:
                //   ApexCharts uses `seriesName` as a GROUPING KEY for scale sharing.
                //   When two yaxis entries have DIFFERENT seriesNames, ApexCharts treats
                //   them as TWO SEPARATE INDEPENDENT SCALES even if both are on the same
                //   physical side (left or right).
                //
                //   Result for 4 series with 4 different seriesNames:
                //     yaxis[0]: "Energy Actual"    → scale 10–34 kWh (fits actual data)
                //     yaxis[1]: "Energy Predicted" → scale 32–43 kWh (fits ONLY predicted)
                //     yaxis[2]: "Temp Actual"      → scale 31–44°C  (fits actual data)
                //     yaxis[3]: "Temp Predicted"   → scale 43–48°C  (fits ONLY predicted)
                //
                //   Since yaxis[1] and yaxis[3] are hidden (show:false), their separate
                //   scales are invisible — but ApexCharts still PLOTS each series against
                //   its own yaxis entry's scale. This means:
                //     • Energy Predicted (32–43 kWh) is scaled INDEPENDENTLY from Energy
                //       Actual (10–34 kWh). The predicted series occupies a DIFFERENT
                //       coordinate space → visually it appears detached and mispositioned.
                //     • Temperature Predicted (43–48°C) is similarly plotted on its own
                //       tiny independent scale → it maps to the BOTTOM of the chart canvas
                //       because 43 at the low end of a 43–48 scale appears as 0% height.
                //
                // FIX: Non-anchor series must share the ANCHOR series' seriesName.
                //   • All left-axis series (energy actual + predicted) share the name of
                //     the FIRST left-axis series ("Energy Actual (kWh)").
                //   • All right-axis series (temp actual + predicted) share the name of
                //     the FIRST right-axis series ("Temperature Actual (°C)").
                //
                //   This tells ApexCharts: "use ONE unified scale for all left-axis
                //   series" and "use ONE unified scale for all right-axis series".
                //   The anchor series' data range determines the full scale, and all
                //   secondary series are plotted against the SAME coordinate space.
                //   Result: predicted values land exactly where they belong relative
                //   to the actual values → no more phantom drops or misalignment.
                //
                // ── EXCEPTION GUARD ──────────────────────────────────────────────────
                //   If no left-axis series exists  → anchorLeftName = undefined → safe
                //   If no right-axis series exists → anchorRightName = undefined → safe
                //   (ApexCharts skips yaxis entries with undefined seriesName gracefully)
                // ─────────────────────────────────────────────────────────────────────
                yaxis: (() => {
                    const firstLeftIdx   = yAxisIndexPerSeries.indexOf(0);
                    const firstRightIdx  = yAxisIndexPerSeries.indexOf(1);
                    // Anchor names: ALL series on the same side share this name
                    const anchorLeftName  = firstLeftIdx  >= 0 ? seriesConsumed[firstLeftIdx]?.name  : undefined;
                    const anchorRightName = firstRightIdx >= 0 ? seriesConsumed[firstRightIdx]?.name : undefined;

                    return seriesConsumed.map((s, i) => {
                        const isRight       = yAxisIndexPerSeries[i] === 1;
                        const isFirstOnAxis = isRight ? (i === firstRightIdx) : (i === firstLeftIdx);

                        // FIX: use anchor name (NOT s.name) so all same-side series share
                        // one unified scale. Non-anchor entries still get their own yaxis
                        // slot (required by ApexCharts positional matching) but are hidden.
                        const sharedSeriesName = isRight ? anchorRightName : anchorLeftName;

                        return {
                            seriesName: sharedSeriesName, // ← shared anchor name, NOT s.name
                            opposite:   isRight,
                            show:       isFirstOnAxis,    // only the first on each side is visible
                            forceNiceScale: true,
                            labels: {
                                style: axisLabelStyle,
                                formatter: (value) => {
                                    // EXCEPTION: null/NaN → '' to suppress broken axis label
                                    if (value == null || isNaN(value)) return '';
                                    return isRight
                                        ? `${Number(value).toFixed(1)}°C`
                                        : Number(value).toFixed(1);
                                }
                            },
                            title: isFirstOnAxis ? {
                                text: isRight
                                    ? (rightAxisProp?.yaxis_title?.titlename || 'Temperature (°C)')
                                    : (leftAxisProp?.yaxis_title?.titlename  || 'Energy (kWh)'),
                                style: { ...axisTitleStyle, color: isRight ? '#E74C3C' : '#0076F6' }
                            } : undefined
                        };
                    });
                })(),
                tooltip: {
                    enabled: true,
                    shared: true,       // shows all 4 series values at the same date
                    intersect: false,
                    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                        // EXCEPTION: core data missing
                        if (!series || dataPointIndex === undefined) {
                            return '<div style="padding:4px;background:#005C8E;color:#fff;">No data</div>';
                        }
                        const timestamp = w.globals.seriesX?.[0]?.[dataPointIndex];
                        // EXCEPTION: timestamp missing or NaN
                        if (!timestamp || isNaN(timestamp)) {
                            return '<div style="padding:4px;background:#005C8E;color:#fff;">Invalid date</div>';
                        }
                        const d = new Date(timestamp);
                        const formattedDate = d.toLocaleDateString('en-US', {
                            timeZone: 'Asia/Kolkata',
                            year: 'numeric', month: 'short', day: 'numeric'
                        });
                        let html = `<div style="display:flex;flex-direction:column;padding:7px 10px;background-color:#005C8E;border-radius:4px;min-width:190px;">`;
                        html += `<div style="font-weight:700;color:#FFFFFF;font-size:11px;margin-bottom:6px;">${formattedDate}</div>`;
                        for (let i = 0; i < series.length; i++) {
                            if (series[i] === undefined || !seriesConsumed[i]) continue;
                            const val    = series[i][dataPointIndex];
                            const color  = w.config.colors?.[i] || '#000000';
                            const name   = seriesConsumed[i].name || '';
                            const isTemp = yAxisIndexPerSeries[i] === 1;
                            html += `
                            <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:3px;">
                                <div style="display:flex;align-items:center;">
                                    <div style="height:8px;width:8px;background-color:${color};border-radius:50%;margin-right:6px;flex-shrink:0;"></div>
                                    <div style="color:#FFFFFF;font-size:10px;">${name}</div>
                                </div>
                                <div style="color:#FFFFFF;font-weight:700;font-size:10px;margin-left:10px;">
                                    ${val == null ? '—' : Number(val).toFixed(isTemp ? 1 : 2) + (isTemp ? '°C' : ' kWh')}
                                </div>
                            </div>`;
                        }
                        if (corrCoeff !== null) {
                            html += `<div style="color:#A8D8FF;font-size:10px;margin-top:5px;border-top:1px solid rgba(255,255,255,0.3);padding-top:4px;">Pearson r = ${corrCoeff}</div>`;
                        }
                        html += `</div>`;
                        return html;
                    },
                    hideEmptySeries: true,
                    fillSeriesColor: false,
                    theme: false,
                    style: { fontSize: "12px", fontFamily: 'Roboto' }
                },
                legend: {
                    show: true,
                    fontSize: extendedProps.legend?.fontsize || '12px',
                    fontFamily: extendedProps.legend?.fontfamily || 'Arial',
                    fontWeight: extendedProps.legend?.fontweight || 'normal',
                    labels: { colors: Array(colorPropertiesCorr.length).fill('var(--legend-text-color)') },
                    customLegendItems: legendNamesCorr,
                    markers: {
                        radius: extendedProps.legend?.marker?.radius || 6,
                        height: extendedProps.legend?.marker?.height || 12,
                        width:  extendedProps.legend?.marker?.width  || 12,
                        fillColors: colorPropertiesCorr
                    }
                }
            };

            setSeriesChart(seriesConsumed);
            setOptions(correlationOptions);
            return;
        }
        // ─────────────────────────────────────────────────────────────────────
        // END CONDITION 2
        // ─────────────────────────────────────────────────────────────────────


        // ─────────────────────────────────────────────────────────────────────
        // STANDARD FLOW — Redux tagcollectionvalue lookup
        // ─────────────────────────────────────────────────────────────────────
        if (!tagcollectionvalue || typeof tagcollectionvalue !== 'object') {
            console.log("Tag collection values not available");
            return;
        }

        const colorPropertiesGeneral = [];
        const colorPropertiesLines = [];
        const widthPropertiesLines = [];
        const curvePropertiesLines = [];
        const legendNamePropertiesLines = [];

        const colorPropertiesBars = [];
        const widthPropertiesBars = [];
        const curvePropertiesBars = [];
        const legendNamePropertiesBars = [];

        const colorPropertiesMarkers = [];
        const widthPropertiesMarkers = [];
        const curvePropertiesMarkers = [];
        const legendNamePropertiesMarkers = [];

        tagProperties.forEach(chartType => {
            if (chartType && chartType.chartprops && chartType.legendname) {
                colorPropertiesGeneral.push(chartType.chartprops.color || '#000000');
                colorPropertiesLines.push(chartType.chartprops.color || '#000000');
                widthPropertiesLines.push(2);
                curvePropertiesLines.push('smooth');
                legendNamePropertiesLines.push(chartType.legendname);
            }
        });

        const seriesConsumed = tagProperties.map(chartType => {
            if (!chartType || !chartType.tagid || !chartType.legendname) {
                return null;
            }

            if (!tagcollectionvalue.hasOwnProperty(chartType.tagid)) {
                return null;
            }

            if (chartType.charttype === "maxlimit" || chartType.charttype === "minlimit") {
                return null;
            }

            const tagData = tagcollectionvalue[chartType.tagid];

            if (!tagData || !Array.isArray(tagData)) {
                return null;
            }

            const processedData = tagData.map(currentobj => {
                if (!currentobj || typeof currentobj !== 'object') return null;
                if (currentobj.x === null || currentobj.x === undefined ||
                    currentobj.y === null || currentobj.y === undefined) return null;
                return { x: currentobj.x, y: currentobj.y };
            }).filter(item => item !== null);

            return {
                name: chartType.legendname,
                type: chartType.charttype || 'line',
                data: processedData
            };
        }).filter(item => item !== null && item.data && item.data.length > 0);

        if (seriesConsumed == undefined || !seriesConsumed || seriesConsumed.length === 0) {
            console.log("No valid series data available");
            setSeriesChart([]);
            setOptions({});
            return;
        }

        const extendedProps = props.widgetprop.props.extended;
        const basicProps = props.widgetprop.props.basic || {};

        const yaxisProperties = {
            forceNiceScale: true,
            labels: {
                show: true,
                style: {
                    colors: 'var(--axis-color)',
                    fontSize: extendedProps.fontsize || '12px',
                    fontFamily: extendedProps.fontfamily || 'Arial',
                    fontWeight: extendedProps.fontweight || 'normal',
                },
                formatter: (value) => {
                    if (value == null || isNaN(value)) return '';
                    return Number(value).toFixed(2);
                },
            },
            title: {
                text: extendedProps.title?.titlename || "",
                style: {
                    color: 'var(--axis-title-color)',
                    fontSize: extendedProps.title?.fontsize || '14px',
                    fontFamily: extendedProps.title?.fontfamily || 'Arial',
                    fontWeight: extendedProps.title?.fontweight || 'bold',
                },
            },
        };

        const optionsConsumption = {
            chart: {
                zoom: { enabled: false },
                type: "line",
                toolbar: { show: false },
                offsetX: 0
            },
            grid: { show: true, borderColor: 'var(--grey-variation)' },
            stroke: {
                show: true,
                width: widthPropertiesLines.length > 0 ? widthPropertiesLines : [2],
                curve: curvePropertiesLines.length > 0 ? curvePropertiesLines : ['smooth'],
            },
            fill: { opacity: 1, type: 'solid' },
            colors: colorPropertiesLines.length > 0 ? colorPropertiesLines : ['#008FFB'],
            plotOptions: { line: {} },
            dataLabels: { enabled: extendedProps.dataLabels_enabled || false },
            xaxis: {
                type: 'datetime',
                tickAmount: Math.max(1, (seriesConsumed[0]?.data?.length || 1) - 1),
                tickPlacement: 'between',
                tooltip: { enabled: false },
                axisBorder: { show: true, color: 'var(--axis-color)' },
                axisTicks: { show: true, height: 3, color: 'var(--axis-color)' },
                labels: {
                    show: true,
                    rotate: -45,
                    rotateAlways: false,
                    hideOverlappingLabels: true,
                    style: {
                        colors: 'var(--axis-color)',
                        fontSize: extendedProps.fontsize || '12px',
                        fontFamily: extendedProps.fontfamily || 'Arial',
                        fontWeight: extendedProps.fontweight || 'normal',
                    },
                    formatter: function(value, timestamp, opts) {
                        if (!opts || !opts.w || !opts.w.config || !opts.w.config.series) return '';
                        if (isNaN(value)) return '';

                        const index = opts.i;
                        if (index === undefined || !opts.w.config.series[0] || !opts.w.config.series[0].data) return '';

                        const thistimestamp = opts.w.config.series[0].data[index]?.x;
                        if (!thistimestamp) return '';

                        const currentformatteddate = new Date(thistimestamp);
                        if (isNaN(currentformatteddate.getTime())) return '';

                        let currxvalue = '';
                        const options = { timeZone: "Asia/Kolkata" };

                        if (currentformatteddate) {
                            switch (dateformatselected) {
                                case 'This Year':
                                case 'Last Year':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, month: "short" });
                                    break;
                                case 'This Month':
                                case 'Last Month':
                                case 'Last 30 days':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric" });
                                    break;
                                case 'This Week':
                                case 'Last Week':
                                case 'Last 7 days':
                                    currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, weekday: "short" });
                                    break;
                                case 'Today':
                                case 'Yesterday':
                                    var hrs = currentformatteddate.getHours();
                                    var hrsstring = hrs.toString();
                                    if (hrsstring.length < 2) hrsstring = "0" + hrsstring;
                                    currxvalue = hrsstring;
                                    break;
                                case 'Last 24 hours':
                                    const hrs24 = currentformatteddate.getHours();
                                    const mins = currentformatteddate.getMinutes();
                                    currxvalue = `${hrs24.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
                                    break;
                                case 'Custom':
                                    if (seriesConsumed[0]?.data?.length > 30) {
                                        currxvalue = (currentformatteddate.getDate() === 1)
                                            ? currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric", month: "short" })
                                            : '';
                                    } else {
                                        currxvalue = currentformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric" });
                                    }
                                    break;
                                default:
                                    currxvalue = '';
                                    break;
                            }
                            return currxvalue;
                        } else {
                            return '';
                        }
                    }
                },
            },
            yaxis: yaxisProperties,
            tooltip: {
                enabled: true,
                enabledOnSeries: undefined,
                custom: function({ series, seriesIndex, dataPointIndex, w }) {
                    if (!series || !series[seriesIndex] || series[seriesIndex][dataPointIndex] === undefined) {
                        return '<div>No data</div>';
                    }
                    const value = series[seriesIndex][dataPointIndex];
                    const timestamp = w.globals.seriesX?.[seriesIndex]?.[dataPointIndex];
                    if (!timestamp) return '<div>No timestamp data</div>';

                    const currentFormattedDate = new Date(timestamp);
                    if (isNaN(currentFormattedDate.getTime())) return '<div>Invalid date</div>';

                    let tooltipString = `<div style="display:flex; flex-direction:column; padding:5px; background-color:#005C8E;">`;
                    const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false };
                    const formattedDate = currentFormattedDate.toLocaleDateString('en-US', options).replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/g, '$3-$1-$2');
                    tooltipString += `<div style="font-weight:600; color:#FFFFFF; background-color:#005C8E;">${formattedDate}</div>`;

                    for (let i = 0; i < series.length; i++) {
                        if (series[i] && series[i][dataPointIndex] !== undefined && seriesConsumed[i]) {
                            const seriesValue = series[i][dataPointIndex];
                            const color = w.config.colors?.[i] || '#000000';
                            tooltipString += `
                            <div style="display:flex; align-items:center; margin-bottom:4px;">
                                <div style="height:8px; width:8px; background-color:${color}; border-radius:50%; margin-right:8px;"></div>
                                <div style="font-weight:600; color:#FFFFFF;">${seriesConsumed[i].name}</div>
                                <div style="margin-left:12px; color:#FFFFFF;">${(seriesValue == null) ? "No Value" : Number(seriesValue).toFixed(2)}</div>
                            </div>`;
                        }
                    }
                    tooltipString += `</div>`;
                    return tooltipString;
                },
                hideEmptySeries: true,
                fillSeriesColor: false,
                theme: false,
                borderRadius: 0,
                style: { fontSize: "12px", fontWeight: 800, fontFamily: 'Roboto' },
            },
            legend: {
                show: true,
                fontSize: extendedProps.legend?.fontsize || '12px',
                fontFamily: extendedProps.legend?.fontfamily || 'Arial',
                fontWeight: extendedProps.legend?.fontweight || 'normal',
                labels: { colors: Array(colorPropertiesLines.length).fill('var(--legend-text-color)') },
                customLegendItems: legendNamePropertiesLines,
                markers: {
                    radius: extendedProps.legend?.marker?.radius || 6,
                    height: extendedProps.legend?.marker?.height || 12,
                    width: extendedProps.legend?.marker?.width || 12,
                    fillColors: colorPropertiesLines
                }
            },
            responsive: [
                {
                    breakpoint: 1000,
                    options: { xaxis: { labels: { rotate: -45, rotateAlways: true } } }
                },
                {
                    breakpoint: 600,
                    options: { xaxis: { labels: { rotate: -60, rotateAlways: true } } }
                }
            ],
        };

        setSeriesChart(seriesConsumed);
        setOptions(optionsConsumption);
    }, [props.widgetprop, tagcollectionvalue, dateformatselected]);

    // ─────────────────────────────────────────────────────────────────────────
    // RENDER — CONDITION 0: FORECAST OVERVIEW TEXT WIDGET
    //
    // Checked here (outside useEffect) because this widget bypasses all chart
    // state — setSeriesChart is never called for it, so seriesChart stays []
    // and the "No data available" guard below would fire incorrectly.
    // Intercepting by widgetname here ensures the text is always rendered.
    //
    // ── EXCEPTION GUARDS ─────────────────────────────────────────────────────
    //   extended missing entirely          → "No description available." shown
    //   extended.text missing / not string → "No description available." shown
    //   extended.text is empty ""          → "No description available." shown
    //   any style prop missing             → each has a safe inline default
    //   theme selector undefined           → color falls back to '#333333'
    //   widgetprop.props.basic missing     → destructured with || {} safely
    // ─────────────────────────────────────────────────────────────────────────
    const renderWidgetName = props?.widgetprop?.widgetname?.trim().toLowerCase();

    if (renderWidgetName === "forecast overview") {
        const extended  = props?.widgetprop?.props?.extended || {};
        const basicProps = props?.widgetprop?.props?.basic || {};

        // EXCEPTION: text missing or not a string → show fallback
        const rawText = extended.text;
        const displayText = (typeof rawText === 'string' && rawText.trim().length > 0)
            ? rawText.trim()
            : 'No description available.';

        // Style props with safe defaults for every possible missing key
        const fontSize   = extended.fontsize   || '14px';
        const fontFamily = extended.fontfamily || 'Roboto, sans-serif';
        const fontWeight = extended.fontweight || 400;
        const lineHeight = extended.lineheight || '1.7';
        const textAlign  = extended.textalign  || 'left';

        // EXCEPTION: theme missing → light mode color as safe default
        const textColor = theme === 'dark'
            ? (extended.color_dark || '#EDEFEE')
            : (extended.color      || '#333333');

        return (
            <div style={{
                display:        'flex',
                alignItems:     'flex-start',
                justifyContent: 'flex-start',
                height:         '85%',
                width:          '100%',
                padding:        '16px 20px',
                boxSizing:      'border-box',
                overflowY:      'auto',
            }}>
                <p style={{
                    fontSize,
                    fontFamily,
                    fontWeight,
                    lineHeight,
                    textAlign,
                    color:   textColor,
                    margin:  0,
                    padding: 0,
                }}>
                    {displayText}
                </p>
            </div>
        );
    }
    // ─────────────────────────────────────────────────────────────────────────
    // END RENDER CONDITION 0
    // ─────────────────────────────────────────────────────────────────────────

    if (!props || !props.widgetprop || !props.widgetprop.props || !props.widgetprop.props.extended) {
        return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '85%' }}>Loading chart...</div>;
    }

    if (!seriesChart || seriesChart.length === 0) {
        return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '85%' }}>No data available</div>;
    }

    // Both Forecast vs Actual and Energy vs Temperature Correlation
    // use chart.type:'line' (correlation uses dual-axis multi-series line, not scatter)
    return (
        <>
            <Chart options={options} series={seriesChart} type="line" height="85%" width="100%" />
        </>
    );
};

export default LineChart;